module.exports = __webpack_public_path__ + "static/media/dashboard.c289e739.svg";